var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._b({ class: _vm.className }, "span", _vm.$attrs, false),
    [
      _vm.src && _vm.isImgExist
        ? [
            _c("img", {
              attrs: { src: _vm.src },
              on: { error: _vm.handleImgLoadError },
            }),
          ]
        : [
            _c(
              "span",
              { staticClass: "avatar-string" },
              [_vm._t("default")],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }